<template>
	<div>
		<div class="modal right fade" id="fabModal" tabindex="-1" style="display: none;" aria-hidden="true">
			<div class="modal-dialog modal-sm shadow-lg mx-0">
				<div v-if="modalcontent=='toolbox'" class="modal-content rounded-0 border-0 pb-4" data-style="toolbox">
					<div class="modal-header justify-content-end border-0"><button class="close mt-1 mr-1" type="button"
							data-dismiss="modal" aria-label="Close"><span aria-hidden="true"><svg class="icon icon-xs">
									<use xlink:href="/assets/img/icon-sprite.svg#global.close"></use>
								</svg></span></button></div>
					<div class="modal-body">
						<div class="container-fluid">
							<div class="row">
								
								<!-- modal-toolbox.html -->
								<div class="col-12">
									<h2 class="h1 mb-5">{{ __('lang.actionbutton.modal.toolbox.toolbox')}}</h2>
									<p class="font-weight-normal">
										{{__('lang.actionbutton.modal.toolbox.selectyourapp')}}
									</p>
									<!--
									<div class="card border-0 rounded-0 mb-5 bg-transparent"><svg
											class="w-50 card-top mb-1" style="height:3rem">
											<use xlink:href="/assets/img/icon-sprite.svg#global.logo.heliosselect"
												xmlns:xlink="http://www.w3.org/1999/xlink"></use>
										</svg>
										<div class="card-body p-0"><a class="stretched-link text-gray-60"
												:href="toolbox.href.heliosselect"
												target="_blank">{{__('lang.actionbutton.modal.toolbox.heliosselect')}}</a>
										</div>
									</div>
									 <div class="card border-0 rounded-0 mb-5 bg-transparent"><svg
											class="w-50 card-top mb-1" style="height:3rem">
											<use xlink:href="/assets/img/icon-sprite.svg#global.logo.kwleasyplan"
												xmlns:xlink="http://www.w3.org/1999/xlink"></use>
										</svg>
										<div class="card-body p-0"><a class="stretched-link text-gray-60"
												:href="toolbox.href.kwleasyplan"
												target="_blank">{{__('lang.actionbutton.modal.toolbox.kwleasyplan')}}</a>
										</div>
									</div> -->
									
									<div class="card border-0 rounded-0 mb-4 bg-transparent"><svg class="w-50 card-top mb-1" style="height:3rem">
											<use xlink:href="/assets/img/icon-sprite.svg#global.logo.heliosselect.grey"
												xmlns:xlink="http://www.w3.org/1999/xlink"></use>
										</svg>
										<div class="card-body p-0">
											<div class="stretched-link text-gray-60">
											<!--<a class="stretched-link text-gray-60" @click.prevent="gotoapp(1)" href="#">  -->
												{{ __('lang.actionbutton.modal.toolbox.heliosselect')}}
											<!-- </a> -->
											</div>
										</div>
									</div>
									<div class="card border-0 rounded-0 mb-4 bg-transparent"><svg class="w-50 card-top mb-1" style="height:3rem">
											<use xlink:href="/assets/img/icon-sprite.svg#global.logo.kwleasyplan"
												xmlns:xlink="http://www.w3.org/1999/xlink"></use>
										</svg>
										<div class="card-body p-0">
											<a class="stretched-link text-gray-60" @click.prevent="gotoapp(2)" href="#">
												{{__('lang.actionbutton.modal.toolbox.kwleasyplan')}}
											</a>
										</div>
									</div>
									<div class="card border-0 rounded-0 mb-5 bg-transparent"><svg class="w-50 card-top mb-1" style="height:3rem">
												<use xlink:href="/assets/img/icon-sprite.svg#global.logo.air1select"
													xmlns:xlink="http://www.w3.org/1999/xlink"></use>
											</svg>
											<div class="card-body p-0">
												<a class="stretched-link text-gray-60" :href="toolbox.href.air1select" target="_blank">
													{{__('lang.actionbutton.modal.toolbox.air1select') }}
												</a>
											</div>
									</div>
									<!-- <div class="card border-0 rounded-0 mb-5 bg-transparent">
										<div class="card-body p-0">
											<a class="stretched-link text-gray-60" @click.prevent="gotoapp(5)" href="#">
												{{__('lang.actionbutton.modal.toolbox.gotohomepage')}}
											</a>
										</div>
									</div> -->

									<p class="font-weight-normal">
	                                	{{__('lang.actionbutton.modal.toolbox.productsworld')}}
	                            	</p>
									<div class="card border-0 rounded-0 mb-4 bg-transparent">
										<svg class="w-50 card-top mb-1" style="height: 3rem;">
											<use xlink:href="/assets/img/icon-sprite.svg#global.logo.helios-website" xmlns:xlink="http://www.w3.org/1999/xlink">
											</use>
										</svg>
										<div class="card-body p-0">
											<a class="stretched-link text-gray-60" @click.prevent="gotoapp(5)" href="#">
												{{__('lang.actionbutton.modal.toolbox.tohomepage') }} 
											</a>
										</div>
	                            	</div>
									<div class="card border-0 rounded-0 mb-4 bg-transparent">
										<svg class="w-50 card-top mb-1" style="height: 3rem;">
											<use xlink:href="/assets/img/icon-sprite.svg#global.logo.heliosphere" xmlns:xlink="http://www.w3.org/1999/xlink">
											</use>
										</svg>
										<div class="card-body p-0"><a href="http://www.heliosventilatoren.de/heliosphere" target="_blank" class="stretched-link text-gray-60">{{__('lang.actionbutton.modal.toolbox.tosphere')}}</a>
										</div>
									</div>
									<!-- 
									<p class="font-weight-normal">{{__('lang.actionbutton.modal.toolbox.infotoolbox')}}
									</p>
									<p class="mb-6"><a class="btn btn-primary border-0"
											:href="toolbox.href.heliosworld"><svg class="icon">
												<use xlink:href="/assets/img/icon-sprite.svg#global.form.send"
													xmlns:xlink="http://www.w3.org/1999/xlink"></use>
											</svg>{{__('lang.actionbutton.modal.toolbox.totoolbox')}}</a></p>
									<p class="font-weight-normal">{{__('lang.actionbutton.modal.toolbox.heliosworld')}}
									</p>
									<p><a class="text-primary" :href="toolbox.href.homepage" target="_blank"><svg
												class="icon icon-rg">
												<use xlink:href="/assets/img/icon-sprite.svg#global.helios"
													xmlns:xlink="http://www.w3.org/1999/xlink"></use>
											</svg>{{__('lang.actionbutton.modal.toolbox.gotohomepage')}}</a>
									</p>  -->
									

								
								</div>




							</div>
						</div>
					</div>
				</div>


				<div v-else-if="modalcontent == 'contact'" class="modal-content rounded-0 border-0 pb-4" data-style="contact">
						<div class="modal-header justify-content-end border-0"><button class="close mt-1 mr-1" type="button"
								data-dismiss="modal" aria-label="Close"><span aria-hidden="true"><svg class="icon icon-xs">
										<use xlink:href="/assets/img/icon-sprite.svg#global.close"></use>
									</svg></span></button></div>
						<div class="modal-body">
							<div class="container-fluid">
								<div class="row">
									<!-- modal-contact.html -->
									<div class="col-12">
										<h2 class="h1 mb-6">{{ __('lang.actionbutton.modal.contact.wearehere') }}</h2>
										<p class="font-weight-normal">
											{{ __('lang.actionbutton.modal.contact.callus') }}</p>
										<p class="mb-6"><a class="h2 d-flex align-items-center text-primary"
												:href="contact.href.phonenumber">
												<svg class="icon mb-0">
													<use xlink:href="/assets/img/icon-sprite.svg#global.phone"
														xmlns:xlink="http://www.w3.org/1999/xlink"></use>
												</svg>{{ __('lang.actionbutton.modal.contact.phonenumber') }}</a>
										</p>
										<!-- <p class="font-weight-normal">
											{{ __('lang.actionbutton.modal.contact.writeus') }}</p>
										<p class="mb-5"><a class="btn btn-primary"
												:href="contact.href.tocontactform">{{ __('lang.actionbutton.modal.contact.tocontactform') }}</a>
										</p> -->
										<p class="font-weight-normal">
											{{ __('lang.actionbutton.modal.contact.tocontactperson') }}</p>
										<p><a class="btn btn-primary"
												:href="contact.href.tocontactpage" @click="gottocontactpage">{{ __('lang.actionbutton.modal.contact.tocontactpage') }}</a>
										</p>
									</div>
									<!-- <div>
										<button class="btn btn-primary border-0 ml-3 px-5" type="button" data-dismiss="modal" aria-label="Close"
										@click.prevent="subscribenewsletter()">
										<svg class="icon">
											<use xlink:href="/assets/img/icon-sprite.svg#global.form.send" xmlns:xlink="http://www.w3.org/1999/xlink">
											</use>
										</svg>SendeEmailTest
										</button>
									</div> -->



									<!-- modal-toolbox.html -->
									




								</div>
							</div>
						</div>
				</div>




			</div>
		</div>
		<div id="fab" class="row m-0 pl-1 pr-3 align-items-center" :data-state="datastate">
			<div class="fab-toggle px-2" role="button" :title="actionbuttontitle" @click="setactionbuttonstate">
				<svg v-if="!actionbuttonstate" class="icon icon-sm text-white">
					<use xlink:href="/assets/img/icon-sprite.svg#global.info"></use>
				</svg>
				<svg v-else class="icon icon-sm text-white">
					<use xlink:href="/assets/img/icon-sprite.svg#global.form.send"></use>
				</svg>

			</div>
			<ul class="nav">
				<li class="nav-item">
					<a class="nav-link px-2" :title="__('lang.actionbutton.toolbox.title')" role="button"
						data-toggle="modal" data-target="#fabModal" data-content="modal-toolbox" data-class="toolbox"
						@click="setmodal('toolbox')">
						<svg class="icon icon-sm m-0 text-white">
							<use xlink:href="/assets/img/icon-sprite.svg#global.fab.config"></use>
						</svg>
					</a>
				</li>
				<li class="nav-item">
					<a class="nav-link px-2" :title="__('lang.actionbutton.contact.title')" role="button"
						data-toggle="modal" data-target="#fabModal" data-content="modal-contact" data-class="contact"
						@click="setmodal('contact')">
						<svg class="icon icon-sm m-0 text-white">
							<use xlink:href="/assets/img/icon-sprite.svg#global.fab.contact"></use>
						</svg>
					</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
//import log from './services/logger/index'
import globalsApi from './services/api/globals'

  export default {
    data() {
      	return {
				actionbuttonstate: false,
				datastate: 'close',
				modalcontent: '',
				actionbuttontitle: this.__('lang.actionbutton.title.quick'),
				
				contact: {
					href: {
						phonenumber: this.__('lang.actionbutton.modal.contact.href.phonenumber'),
						tocontactform: this.__('lang.actionbutton.modal.contact.href.tocontactform'),
						tocontactpage: this.__('lang.actionbutton.modal.contact.href.tocontactpage')
					}
				},
				toolbox: {
					href: {
						heliosselect: this.__('lang.actionbutton.modal.toolbox.href.heliosselect'),
						kwleasyplan: this.__('lang.actionbutton.modal.toolbox.href.kwleasyplan'),
						air1select: this.__('lang.actionbutton.modal.toolbox.href.air1select'),
						heliosworld: this.__('lang.actionbutton.modal.toolbox.href.heliosworld'),
						homepage: this.__('lang.actionbutton.modal.toolbox.href.homepage'),
					},

				}
    	}
	},
	methods: {
		setactionbuttonstate: function () { 
			this.actionbuttonstate = !this.actionbuttonstate;
			this.datastate = this.actionbuttonstate  ? 'open' : 'close';
			this.actionbuttontitle = this.actionbuttonstate ? this.__('lang.actionbutton.title.close') : this.__('lang.actionbutton.title.quick')
		},
		setmodal: function (modalcontent) { 
			this.modalcontent = modalcontent
		},
		async gottocontactpage () {
			var client
			var response = await globalsApi.getClients({ id: 5 });

			[client] = response.data
			if (response.status >= 400) {
				this.$store.dispatch('alert/setAlert', { type: 'danger', message: this.__('lang.floatactionbutton.alert.load_client_failed') })
				return
			}
			if (this.selectedlocale.country == 'aut') this.contact.href.tocontactpage = client.url + '/at/kontakt-at' //  this.__('lang.actionbutton.modal.contact.href.tocontactpage_at')
			else if (this.selectedlocale.country == 'deu' && this.selectedlocale.language == 'de') this.contact.href.tocontactpage =  client.url + '/de/kontakt'//this.__('lang.actionbutton.modal.contact.href.tocontactpage_de')
			else if (this.selectedlocale.country == 'deu' && this.selectedlocale.language == 'en') this.contact.href.tocontactpage = client.url + '/en/contact'//this.__('lang.actionbutton.modal.contact.href.tocontactpage_en')
			var app_url= this.contact.href.tocontactpage
			setTimeout(() => {
				window.open(app_url, "_blank");
			})
		},
		async gotoapp(client_id) { 
			var client
			var app_url = ''
			
			/* console.log('gotoapp client_id:')
			console.log(client_id) */

			var response = await globalsApi.getClients({ id: client_id });

			[client] = response.data
			if (response.status >= 400) {
				this.$store.dispatch('alert/setAlert', { type: 'danger', message: this.__('lang.floatactionbutton.alert.load_client_failed') })
				return
			}



			
			if (this.user.auth) {
				
				/* await axios.post('/get/clients', { id: client_id }).then(response => {
					console.log('client response.data')
					console.log(response.data)
					[client] = response.data
				})
				.catch(function (error) {
						this.$store.dispatch('alert/setAlert', { type: 'danger', message: this.__('lang.floatactionbutton.alert.load_client_failed') })
				}.bind(this)) */

		
				
				await axios.post('/user/access/token', { navigation: 1 }).then(res => {
					
					if (client_id == 5) app_url = client.url + '/' + this.$lang().locale + '?access_token=' + res.data.access_token
					else if (client_id == 2) app_url = client.url + '/' + this.$lang().locale + '?access_token=' + res.data.access_token
					else app_url = client.url + '/login/token/exchange/?access_token=' + res.data.access_token

					//else if (client_id == 1) app_url = '/' + this.$lang().locale + '?access_token=' + res.data.access_token
/* 
					console.log('gotoapp app_url:')
					console.log(app_url) */


					//window.parent.location.href = app_url;
					//window.open(app_url, "_blank");
					setTimeout(() => {
						window.open(app_url, "_blank");
					})
				}).catch(function (error) {
					this.$store.dispatch('alert/setAlert', { type: 'danger', message: this.__('lang.floatactionbutton.alert.load_app_failed') })
				}.bind(this))
			}
			else {
				//ToDo:
				//window.parent.location.href = client.url;
				app_url =  client.url;
				
				/* switch (client_id) {
					case 1:
						var app_url = this.toolbox.href.heliosselect;
						break;
					case 2:
						var app_url = this.toolbox.href.kwleasyplan;
						break;
					case 5:
						var app_url = this.toolbox.href.homepage;
						break;
					default:
						var app_url = this.toolbox.href.heliosselect;
				}  */
				//window.parent.location.href = app_url;
				setTimeout(() => {
					window.open(app_url, "_blank");
				})
				
			}
			
		},
		/* async subscribenewsletter () { 
			await axios.post('/subscribenewsletter', { navigation: 1 }).then(res => {
				console.log('mailresdata:', res.data)
			}).catch(function (error) { console.log('mailresdata error:', error) })

		} */
	},
	computed: {
		user: {
			get() {
				return this.$store.state.user.user
			},
			set(value) {
				this.$store.commit('user/updateUser', value)
			}
		},
		selectedlocale: {
			get() {
				return this.$store.state.user.selectedlocale
			},
			set(value) {
				this.$store.commit('user/updateSelectedlocale', value)
			}
		}
    	
    },
    watch: {
    	
    },
	mounted() {	
		this.actionbuttonstate = false;
		

	}
  }
</script>